<template>
    <section>
        <div class="hero is-white is-small">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        Reportería {{ this.unitName }}
                    </h1>

                    <ValidationObserver ref="observer" 
                        class="columns is-centered is-multiline" v-slot="{ invalid }">

                        <div class="column">
                            <b-field label="Año desde:" >

                                <multiselect v-model="minYear" :options="years" :searchable="true"
                                    :close-on-select="true" placeholder="Elija un año" :allow-empty="false"
                                    selectLabel="Presiene para seleccionar" selectedLabel="Seleccionado"
                                    deselectLabel="Presione para deseleccionar" />

                            </b-field>
                        </div>

                        <div class="column">
                            <b-field label="Año hasta:" :type="{ 'is-danger': verifyYears }"
                                :message="{ 'Año hasta no puede ser menor al Año desde': verifyYears }">

                                <multiselect v-model="maxYear" :options="years" :searchable="true"
                                    :close-on-select="true" placeholder="Elija un año" :allow-empty="false"
                                    selectLabel="Presiene para seleccionar" selectedLabel="Seleccionado"
                                    deselectLabel="Presione para deseleccionar" />

                            </b-field>
                        </div>

                        <div v-show="fromFaculty"  class="column">
                            <b-field label="Seleccione una Unidad">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <multiselect 
                                        v-model="selectedUnit" :options="optionDepartaments" label="name" track-by="id"
                                        placeholder="Seleccione Unidad" selectLabel="Presione para seleccionar"
                                        selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                                        :multiple="false" :allow-empty="false">
                                        <template v-slot:noOptions>
                                            No existen datos
                                        </template>
                                        <span slot="noResult">
                                            No se encontraron elementos.
                                        </span>
                                    </multiselect>
                                    <span class="validation-alert">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </b-field>
                        </div>

                        <div class="column is-narrow">
                            <br>
                            <b-field label=" ">
                                <b-button type="is-info" label="Aplicar Filtro" native-type="submit"
                                    @click="checkFilters()" />
                            </b-field>
                        </div>

                    </ValidationObserver>

                    <div v-if="canCalculateIndicators">
                        <br>

                        <h1 class="title is-4 mb-2">
                            Calcular Indicador
                        </h1>

                        <ValidationObserver ref="observerCalculateIndicator" 
                            class="columns is-centered is-multiline" v-slot="{ invalid }">

                            <div class="column">
                                <ValidationProvider name="Año desde"
                                    :rules="{ start_date_before_end_date: maxYearIndicator, required: true }"
                                    v-slot="{ errors, failedRules }">
                                    <b-field label="Año desde: *"
                                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <multiselect v-model="minYearIndicator" :options="years" :searchable="true"
                                            :close-on-select="true" placeholder="Elija un año" :allow-empty="false"
                                            selectLabel="Presiene para seleccionar" selectedLabel="Seleccionado"
                                            deselectLabel="Presione para deseleccionar" />
                                    </b-field>
                                </ValidationProvider>
                            </div>

                            <div class="column">
                                <ValidationProvider name="Año hasta"
                                    :rules="{ end_date_not_before_start_date: minYearIndicator, required: true }"
                                    v-slot="{ errors, failedRules }">
                                    <b-field label="Año hasta: *"
                                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <multiselect v-model="maxYearIndicator" :options="years" :searchable="true"
                                            :close-on-select="true" placeholder="Elija un año" :allow-empty="false"
                                            selectLabel="Presiene para seleccionar" selectedLabel="Seleccionado"
                                            deselectLabel="Presione para deseleccionar" />
                                    </b-field>
                                </ValidationProvider>
                                
                            </div>

                            <div v-if="fromFaculty" class="column">
                                <ValidationProvider name="Unidad" :rules="fromFaculty ? 'required': ''"
                                    v-slot="{ errors, failedRules }">
                                    <b-field label="Seleccione una Unidad *"
                                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <multiselect 
                                            v-model="selectedUnitIndicator" :options="optionDepartaments" label="name" track-by="id"
                                            placeholder="Seleccione Unidad" selectLabel="Presione para seleccionar"
                                            selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                                            :multiple="false" :allow-empty="false">
                                            <template v-slot:noOptions>
                                                No existen datos
                                            </template>
                                            <span slot="noResult">
                                                No se encontraron elementos.
                                            </span>
                                        </multiselect>
                                    </b-field>
                                </ValidationProvider>
                            </div>

                            <div class="column">
                                <ValidationProvider name="Indicator" rules="required"
                                    v-slot="{ errors, failedRules }">
                                    <b-field label="Seleccione un Indicador *"
                                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                        <multiselect 
                                            v-model="selectedIndicator" :options="indicators" :custom-label="codeWithName" track-by="id"
                                            placeholder="Seleccione Indicador" selectLabel="Presione para seleccionar"
                                            selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                                            :multiple="false" :allow-empty="false">
                                            <template v-slot:noOptions>
                                                No existen datos
                                            </template>
                                            <span slot="noResult">
                                                No se encontraron elementos.
                                            </span>
                                        </multiselect>
                                    </b-field>
                                </ValidationProvider>
                            </div>

                            <div class="column is-narrow">
                                <br>
                                <b-field label=" ">
                                    <b-button label="Calcular Indicador" type="is-primary" @click="checkIndicator()"/>
                                </b-field>
                            </div>

                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showTabs" class="container mt-6">

            <div class="box">

                <b-tabs position="is-centered" v-model="currentTab" :multiline="true">
                    <b-tab-item v-for="item in items" v-bind:key="item.content" :value="item.content" :label="item.tab"
                        :icon="item.icon" />
                </b-tabs>
                <!-- COMPONENTE AQUI -->
                <keep-alive>
                    <component v-bind:is="currentTab" :minYear="minYear" :maxYear="maxYear" 
                        :unitId="unitIdToChildren" :changeFilter="changeFilter" :publicationTypesBook="publicationTypesBook"
                        :projectTypes="projectTypes" :partnerEntities="partnerEntities" :patentStates="patentStates"
                        :studyTypes="studyTypes" :hierarchyTypes="hierarchyTypes"/>
                </keep-alive>

            </div>

        </div>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />

    </section>
</template>

<script>
import UnitIndicatorPublicationTab from './unit_indicator_publicaton_tab.vue'
import UnitIndicatorPublicationBook from './unit_indicator_publication_book_tab.vue'
import UnitIndicatorProject from './unit_indicator_project_tab.vue'
import UnitIndicatorPatent from './unit_indicator_patent_tab.vue'
import UnitIndicatorAcademic from './unit_indicator_academic_tab.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import axios from 'axios'
export default {

    name: 'IndicatorByUnit',

    components: {
        UnitIndicatorPublicationTab, UnitIndicatorPublicationBook, UnitIndicatorProject, UnitIndicatorPatent, UnitIndicatorAcademic,
    },

    props: [
        'userId', 'cargoPrincipal', 'unitName', 'unitIndicators', 'unitId', 'fromFaculty', 'departaments', 'canCalculateIndicators',
        'publicationTypesBook', 'projectTypes', 'partnerEntities', 'patentStates', 'studyTypes', 'hierarchyTypes'
    ],

    data() {
        return {
            minYear: new Date().getFullYear() - 5,
            maxYear: new Date().getFullYear(),
            verifyYears: false,
            years: Array.from({length:(new Date().getFullYear()-2000+1)},(v,k)=>k+2000).reverse(),
            isLoading: false,
            currentTab: 'UnitIndicatorPublicationTab',
            selectedUnit: null,
            showTabs: false,
            optionDepartaments: [],
            items: [
                { tab: 'Publicaciones en Revista', content: 'UnitIndicatorPublicationTab', icon: "newspaper" },
                { tab: 'Publicaciones en Libro', content: 'UnitIndicatorPublicationBook', icon: "book" },
                { tab: 'Proyectos', content: 'UnitIndicatorProject', icon: "folder-open" },
                { tab: 'Patentes', content: 'UnitIndicatorPatent', icon: "lightbulb" },
                { tab: 'Cuerpo Académico', content: 'UnitIndicatorAcademic', icon: "user-graduate" },
            ],
            changeFilter: false,
            unitIdToChildren: this.unitId,
            minYearIndicator: new Date().getFullYear() - 5,
            maxYearIndicator: new Date().getFullYear(),
            selectedUnitIndicator: null,
            selectedIndicator: null,
            indicators: [],
        }
    },

    async created() {
        
        if (!this.fromFaculty) {
            this.changeFilter = !this.changeFilter
            this.showTabs = true
        } else {
            this.optionDepartaments = this.departaments
        }
        await this.getIndicators()
    },

    methods: {

        isAuthorized(nombre){
        let objeto = this.permisos.find(obj => obj.nombre === nombre)
            if (objeto!==undefined){
                return objeto.value
            }
            else{
                return false
            }
        },

        async checkFilters(){

            const valid = await this.$refs.observer.validate()

            if (!valid && this.fromFaculty) {

                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Porfavor seleccione una Unidad.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
            }

            if ((this.minYear <= this.maxYear) || (this.minYear == null) || (this.maxYear == null)) {

                this.verifyYears = false

                if (this.fromFaculty) {
                    this.unitIdToChildren = this.selectedUnit.id
                }
                
                this.changeFilter = !this.changeFilter

                this.showTabs = true
            }else{
                this.verifyYears = true
            }
        },

        async getIndicators() {
            this.isLoading = true
            await axios
                .get('/indicators/get-indicator-for-units.json')
                .then(response => {
                    this.indicators = response.data
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer los datos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        codeWithName({code, name}) {
            return `${code} - ${name}`
        },

        async checkIndicator(){

            let valid = await this.$refs.observerCalculateIndicator.validate()

            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Uno de los campos para calcular indicadores presenta errores.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
            }

            this.$buefy.dialog.confirm({
                title: 'Calcular Indicador',
                message: '¿Está seguro de calcular el indicador?',
                type: 'is-info',
                ariaRole: 'alertdialog',
                ariaModal: true,
                cancelText: 'Cancelar',
                onConfirm: () => this.calculateIndicator()
            })
        },

        async calculateIndicator(){
            this.isLoading = true
            await axios
                .post('/dashboards/calculate-indicator-unit.json',{
                    unit_id: this.fromFaculty ? this.selectedUnitIndicator.id : this.unitId,
                    indicator_id: this.selectedIndicator.id,
                    minYear: this.minYearIndicator,
                    maxYear: this.maxYearIndicator,
                })
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Logrado',
                        message: 'El Indicador fue calculado satisfactoriamente.',
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.changeFilter = !this.changeFilter
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al calcular el Indicador.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    }

}
</script>